var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      staticClass: "mb-0 expert-sync-history",
      attrs: { "body-class": "overflow-y-auto" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c("h2", { staticClass: "section-separator-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.t("filogix.expertSync.yourSyncHistory")) +
                    "\n    "
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("v-server-table", {
        key: "syncHistoryTable-" + _vm.selectedEventType,
        ref: "syncHistoryTable",
        staticClass:
          "vue-custom-table no-pagination vue-custom-table-infinite vue-custom-table-with-filters",
        attrs: { columns: _vm.table.columns, options: _vm.table.options },
        on: { loading: _vm.handleTableLoading, loaded: _vm.handleTableLoaded },
        scopedSlots: _vm._u([
          {
            key: "h__eventType",
            fn: function () {
              return [
                _c(
                  "b-dropdown",
                  {
                    attrs: {
                      id: _vm.selectedEventType,
                      "no-caret": "",
                      text: _vm.t("application-form.type"),
                      variant: "transparent",
                      "toggle-class": "bs-0 p-0",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "button-content",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "VueTables__heading" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.t("application-form.type")) +
                                    "\n            "
                                ),
                                _c("icon", { attrs: { name: "filter" } }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _vm._v(" "),
                    _vm._l(_vm.eventTypes, function (ref) {
                      var id = ref.id
                      var text = ref.text
                      return _c(
                        "b-dropdown-item",
                        {
                          key: id,
                          staticClass: "clickable",
                          on: {
                            click: function ($event) {
                              return _vm.handleFilterByEventType(id)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "pretty p-round p-default" },
                            [
                              _c("input", {
                                attrs: {
                                  id: id,
                                  type: "radio",
                                  value: "none",
                                  name: "select-event-type-" + id,
                                },
                                domProps: {
                                  checked: _vm.selectedEventType == id,
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "state p-primary" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "text-light-gray",
                                    attrs: { for: id },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(text) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "createdAt",
            fn: function (ref) {
              var row = ref.row
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("formatDateHour")(row.createdAt)) +
                    "\n    "
                ),
              ]
            },
          },
          {
            key: "result",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "badge",
                  {
                    staticClass: "m-0 badge-notification float-none",
                    attrs: { type: row.isError ? "danger" : "success" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          row.isError
                            ? _vm.t("global.words.failed")
                            : _vm.t("global.words.succeeded")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "eventType",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "badge",
                  {
                    staticClass: "m-0 badge-notification float-none",
                    attrs: { type: "primary" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getApplicationSyncEventTypeText(row.eventType)
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "errorMessage",
            fn: function (ref) {
              var row = ref.row
              return [_c("sync-error", { attrs: { status: row } })]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }